import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext(null);

// Demo users for the fleet management app
const DEMO_USERS = {
  'demo@fleets.com': {
    password: 'demo123',
    name: 'John Manager',
    role: 'manager',
    email: 'demo@fleets.com',
  },
  'driver@fleets.com': {
    password: 'demo123',
    name: 'Mike Driver',
    role: 'driver',
    email: 'driver@fleets.com',
  },
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const login = async (email, password) => {
    setIsLoading(true);

    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 500));

    const normalizedEmail = email.toLowerCase().trim();
    const demoUser = DEMO_USERS[normalizedEmail];

    if (demoUser && demoUser.password === password) {
      const userData = {
        email: demoUser.email,
        name: demoUser.name,
        role: demoUser.role,
      };
      setUser(userData);
      setIsLoading(false);
      return { success: true, user: userData };
    }

    setIsLoading(false);
    return { success: false, error: 'Invalid email or password' };
  };

  const logout = () => {
    setUser(null);
  };

  const isManager = () => {
    return user?.role === 'manager';
  };

  const isDriver = () => {
    return user?.role === 'driver';
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        isAuthenticated: !!user,
        login,
        logout,
        isManager,
        isDriver,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
